// LanguageSwitcher.js
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

function LanguageSwitcher() {

  const { i18n } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const languages = [
    { code: "en", label: "English" },
    { code: "sn", label: "සිංහල" },
    { code: "tn", label: "தமிழ்" },
  ];

  const handleSelect = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        className="p-2 rounded-full hover:bg-gray-200 transition-colors flex items-center gap-2"
        onClick={() => setOpen((v) => !v)}
        aria-label="Select language"
      >
        <span className="text-sm font-medium text-gray-700">
          {(() => {
            const label = languages.find((lang) => lang.code === i18n.language)?.label || 'En';
            if (i18n.language === 'sn') return 'සිං';
            if (i18n.language === 'tn') return 'தம';
            return label.slice(0,2);
          })()}
        </span>
        <div className="p-1 rounded-full bg-gradient-to-r from-[#f30b19] to-[#980c19]">
          <Globe className="w-5 h-5 text-white" aria-label="Language globe icon" />
        </div>
      </button>
      {open && (
        <div className="absolute right-0 max-md:left-2 mt-2 w-32 bg-white border rounded shadow-lg z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              className={`block w-full text-left px-4 py-2 hover:bg-red-100 ${i18n.language === lang.code ? 'font-bold text-[#f30b19]' : ''}`}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
